<template>
	<div id="aboutUs">
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<nav-head></nav-head>
		<!-- 关于我们 -->
		<div class="aboutUs">
			<div class="aboutUsContent">
				<!-- 公司介绍 -->
				<div class="introduce">
					<!-- 左侧图片 -->
					<div class="leftImg">
						<el-skeleton style="width:570px" animated :loading="imgLoading">
						  <template #template>
						    <el-skeleton-item variant="image" style="width: 570px; height:380px" />
						  </template>
						  <template #default>
							<img :src="descLeftImg" width="570" height="380">
						  </template>
						</el-skeleton>
					</div>
					<!-- 右侧文字介绍 -->
					<div class="ml-3 mt-2">
						<!-- 标题文字 -->
						<div>
							<span style="font-size:24px;">公司介绍</span>
							<div style="border: 1px solid #C32A1A; width: 50px;margin-top:10px;"></div>
						</div>
						<!-- 介绍信息 -->
						<div class="mt-2" style="max-height:300px;overflow: auto;font-size: 14px;">
							<div v-html="aboutDesc"></div>
						</div>
					</div>
				</div>
				<!-- 数字统计矩阵 -->
				<div class="census">
					<el-card class="box-card censusCard" v-for="o in descNumber" :key="o">
					  <div>
						  <!-- 数量级 -->
						  <div class="text-center font-weight-bold" style="font-size: 24px;">{{o.number}}</div>
						  <!-- 数量级描述 -->
						  <div class="text-center pt-2" style="color: #999;">{{o.name}}</div>
					  </div>
					</el-card>
				</div>
				<!-- 成功案例 -->
				<div class="serviceNum">
					<div class="d-flex" style="justify-content: space-between;cursor: pointer;">
						<div class="successTitle">
							成功案例
							<div style="width:38px;height:2px;background-color: #C32A1A;margin-top: 5px;"></div>
						</div>
						<div style="border: 1px solid #C32A1A;color: #C32A1A;position: relative;top:2px" class="p-2"
						@click="goList(1)">查看更多</div>
					</div>
					<!-- 成功案例队列 -->
					<div class="successList">
						<!-- 队列 -->
						<div class="slist"  v-for="(item,index) in successArr" :key="index" style="cursor: pointer;" 
						@click="goNewsDetail(item,'成功案例','/socialResponsibility?index=1','success')">
							<!-- 左侧图片 -->
							<div class="leftImg">
								<img :src="item.logoUrl" width="285" height="130">
							</div>
							<!-- 右侧描述 -->
							<div class="rightDesc">
								<!-- 标题 -->
								<div class="descTitle">
									{{item.name}}
								</div>
								<!-- 简介 -->
								<div class="descInfo">
									<div>{{item.introduce}}</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 社会责任 -->
				<div class="duty">
					<div class="d-flex" style="justify-content: space-between;">
						<div class="dutyTitle">
							社会责任
							<div style="width:38px;height:2px;background-color: #C32A1A;margin-top: 5px;"></div>
						</div>
						<div style="border: 1px solid #C32A1A;color: #C32A1A;position: relative;top:2px;cursor: pointer;" class="p-2"
						@click="goList(2)">查看更多</div>
					</div>
					<!-- 社会责任四矩阵 -->
					<div class="dutyContent">
						<!-- 卡片 -->
						<div class="dutyCard" v-for="(o,oIndex) in dutyArr" :key="oIndex" 
						@click="goNewsDetail(o,'社会责任','/socialResponsibility?index=2','social')" style="cursor: pointer;">
							<!-- 图片 -->
						  <div class="imgDesc" :class="{'float-right': oIndex > 1,'float-left':oIndex <= 1}">
							  <img :src="o.logoUrl" width="300" height="300"/>
						  </div>
						  <!-- 信息描述 -->
						  <div class="descInfo">
							<!-- 标题 -->
							<div class="descInfoTitle">
								<span :title="o.name">{{o.name.length > 10 ? o.name.substr(0,10) +'...':o.name}}</span>
								<div style="border: 1px solid #C32A1A; width: 50px;margin-top:10px;"></div>
							</div>
							<!-- 详细内容 -->
							<div class="descContent">
								{{o.introduce}}
							</div>
						  </div>
						</div>
					</div>
				</div>
				<!-- 人才招聘 -->
				<div class="recruit">
					<div class="d-flex" style="justify-content: space-between;">
						<!-- 人才招聘标题 -->
						<div class="recruitTitle">人才招聘
						<div style="width:38px;height:2px;background-color: #C32A1A;margin-top: 5px;"></div>
						</div>
						<div style="border: 1px solid #C32A1A;color: #C32A1A;position: relative;top:2px;cursor: pointer;" class="p-2"
						@click="goList(3)">查看更多</div>
					</div>
					<div class="recruitContent">
						<!-- 左侧图片 -->
						<div class="leftImg">
							<el-skeleton style="width:600px;height:400px;" :loading="recruitLoading" animated>
							    <template #template>
									<el-skeleton-item
							          variant="image"
							          style="width:600px; height: 400px;"/>
							    </template>
							    <template #default>
									<img :src="recruitUrl" width="600" height="400">
							    </template>
							</el-skeleton>
						</div>
						<!-- 右侧新闻列表 -->
						<div class="rightNewsList">
							<!-- 标题 -->
							<div class="pt-5">
								<span class="rightNewsListTitle">去拼搏 去实现梦想</span>
								<div style="border: 1px solid #C32A1A; width: 50px;margin-top:10px;"></div>
							</div>
							<!-- 文字信息 -->
							<div class="desckh">
								<span>未来三年:</span>
								<p>让90后核心管理者超过30%,激发更多年轻人的工作热情，我们需要你！</p>
							</div>
							<!-- 招聘信息 -->
							<div class="recruitInfo">
								<div v-for="(item,index) in recruitArr" :key="index" class="infoTitle">
									<p @click="goNewsDetail(item,'人才招聘','/socialResponsibility?index=3','recruit')"
									style="font-size: 14px;color: #409EFF;">{{item.name}}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 发展历程 -->
										<div class="history">
											<div class="historyTitle">
												发展历程
												<div style="width:38px;height:2px;background-color: #C32A1A;margin-top: 5px;"></div>
											</div>
											<div class="historyListContent">
							<!-- 						<el-timeline>
												  <el-timeline-item :timestamp="item.historyTime" placement="top" v-for="(item,index) in historyArr" :key="index">
													<el-card>
													  <h5>{{item.name}}</h5>
													</el-card>
												  </el-timeline-item>
												</el-timeline> -->
											<img src="../../assets/img/aboutUs/发展历程图.jpg" style="width: 100%;">
											</div>
										</div>
			</div>
		</div>
		<!-- 底部导航 -->
		<div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
	import {
		ref,
	} from 'vue'
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import showCard from '@/components/showCard/showCard.vue'
	import ModuleTitle from '@/components/moduleTitle/moduleTitle.vue'
	import Footer from '@/components/footer/footer.vue'
	export default{
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			showCard,
			ModuleTitle,
			Footer
		},
		data() {
			return {
				// 人才招聘封面
				recruitUrl:'',
				// 人才招聘列表
				recruitArr:[],
				// 公司介绍
				aboutDesc:'',
				// 公司介绍左侧图片
				descLeftImg:'',
				imgLoading:false,
				recruitLoading:false,
				// 数据列表矩阵
				descNumber:[],
				// 成功案例
				successArr:[],
				// 社会责任
				dutyArr:[],
				// 发展历史
				historyArr:[]
			}
		},
		mounted() {
			this.getImg()
			this.getDesc()
			this.getAecruitArr()
			this.getLeftDescImg()
			this.getDescNumber()
			this.getSuccess()
			this.getDutyArr()
			this.getHistory()
		},
		methods: {
			goList(index){
				let routeData = this.$router.resolve({
					path:'/socialResponsibility',
					query:{
						index
					}
				})
				window.open(routeData.href, '_blank');
			},
			// 点击后前往新闻详情页
			goNewsDetail(item,mbx,mbxLink,newsType){
				if(item.reprintMark){
					return window.open(item.reprintUrl, '_blank');
				}
				let routeData = this.$router.resolve({
					path:'/newsDetail',
					query:{
						id:item.id,
						mbx,
						mbxLink,
						newsType
					}
				})
				window.open(routeData.href, '_blank');
			},
			// 获取封面
			getImg(){
				let vm = this
				vm.recruitLoading = true
				this.axios.get('/api/material/findMaterial').then(res => {
					vm.recruitUrl = res.data.data.recruitUrl
					vm.recruitLoading = false
				})
			},
			// 获取公司介绍
			getDesc(){
				let vm = this
				this.axios.get('/api/company/introduce/findAll').then(res => {
					vm.aboutDesc = res.data.data.detail
				})
			},
			// 公司介绍左侧图片
			getLeftDescImg(){
				let vm = this
				vm.imgLoading = true
				this.axios.get('/api/material/findMaterial').then(res => {
					vm.descLeftImg = res.data.data.companyIntroduceUrl
					vm.imgLoading = false
				}).catch(err=>{
					vm.imgLoading = false
				})
			},
			// 获取数字统计矩阵
			getDescNumber(){
				let vm = this
				this.axios.get('/api/census/findHot').then(res => {
					vm.descNumber = res.data.data
				})
			},
			// 获取成功案例
			getSuccess(){
				let vm = this
				this.axios.get('/api/success/case/findHot').then(res => {
					vm.successArr = res.data.data
				})
			},
			// 社会责任
			getDutyArr(){
				let vm = this
				this.axios.get('/api/society/findHot').then(res => {
					vm.dutyArr = res.data.data
				})
			},
			// 获取人才招聘列表
			getAecruitArr(){
				let vm = this
				this.axios.get('/api/recruit/findHot').then(res => {
					vm.recruitArr = res.data.data
				})
			},
			// 公司发展历程
			getHistory(){
				let vm = this
				this.axios.get('/api/history/findAll').then(res => {
					vm.historyArr = res.data.data
				})
			}
		},
	}
</script>

<style scoped>
	/* 外层div */
	.aboutUs{
		width: 100%;
		min-height: 800px;
		margin-bottom: 50px;
	}
	.aboutUs .aboutUsContent{
		width: 1200px;
		min-height: 800px;
		margin: 0 auto;
	}
	/* 公司介绍 */
	.introduce{
		display: flex;
		width: 1200px;
		height:380px;
		margin-top:20px;
	}
	.introduce .leftImg{
		width: 570px;
		height: 380px;
	}
	.introduce .rightDesc{
		width: 550px;
		height: 340px;
		margin:20px 0 0 30px;
	}
	.introduce .rightDesc .descInfo{
		margin-top: 25px;
		color: #999;
	}
	/* 数字统计矩阵 */
	.census{
		display: flex;
		justify-content: space-between;
		margin-top:50px;
	}
	.census .censusCard{
		width:225px;
		height: 100px;
	}
	/* 成功案例 */
	.serviceNum{
		width:1200px;
		margin-top:50px;
	}
	.serviceNum .successTitle{
		font-size: 20px;
		font-weight: bold;
	}
	.serviceNum .successList{
		width: 1200px;
		min-height:300px;
		margin-top: 20px;
	}
	.serviceNum .successList .slist{
		width: 1200px;
		height: 130px;
		border: 1px solid #eee;
		margin-bottom:15px;
		display: flex;
	}
	.serviceNum .successList .slist .leftImg{
		width:285px;
		height: 130px;
		background-color: #eee;
	}
	.serviceNum .successList .slist .rightDesc{
		margin-left: 20px;
		width: 850px;
		height: 90px;
		margin-top:20px;
	}
	.serviceNum .successList .slist .rightDesc .descTitle{
		color: #333;
		font-size:18px;
		font-weight: bold;
	}
	.serviceNum .successList .slist .rightDesc .descInfo{
		padding-top:15px;
		font-size: 14px;
		color: #999;
	}
	/* 社会责任 */
	.duty{
		width:1200px;
		margin-top:100px;
	}
	.duty .dutyTitle{
		font-size: 20px;
		font-weight: bold;
	}
	.duty .dutyContent{
		display: flex;
		flex-wrap:wrap;
		justify-content: space-between;
		margin-top: 20px;
	}
	.duty .dutyContent .dutyCard{
		width: 580px;
		height: 300px;
		margin-bottom:40px;
		--el-card-padding:0 !important;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
	.duty .dutyContent .dutyCard .imgDesc{
		width: 300px;
		height: 300px;
		background-color: #eee;
	}
	.duty .dutyContent .dutyCard .descInfo{
		width: 250px;
		height: 270px;
		float: left;
		margin-left: 20px;
		margin-top: 15px;
	}
	.duty .dutyContent .dutyCard .descInfo .descInfoTitle{
		padding-top:40px;
	}
	.duty .dutyContent .dutyCard .descInfo .descInfoTitle span{
		font-size:18px;
		font-weight: bold;
	}
	.duty .dutyContent .dutyCard .descInfo .descContent{
		color: #999;
		margin-top:18px;
	}
	/* 人才招聘 */
	.recruit{
		width: 1200px;
		margin-top: 50px;
	}
	.recruit .recruitTitle{
		font-size: 20px;
		font-weight: bold;
	}
	.recruit .recruitContent{
		margin-top: 20px;
		display: flex;
		background-color: #eee;
	}
	.recruit .recruitContent .rightNewsList{
		width: 500px;
		height: 350px;
		margin-left: 30px;
		margin-top: 30px;
	}
	.recruit .recruitContent .rightNewsList .rightNewsListTitle{
		font-size: 18px;
		font-weight: bold;
	}
	.recruit .recruitContent .rightNewsList .desckh{
		margin-top: 20px;
		color: #999;
		font-size: 14px;
	}
	.recruit .recruitInfo{
		color: #606266;
	}
	.recruit .recruitInfo p:hover{
		color: #C32A1A;
		cursor: pointer;
	}
	/* 发展历程 */
	.history{
		margin-top:50px;
		position: relative;
		top:50px
	}
	.history .historyTitle{
		font-size: 20px;
		font-weight: bold;
	}
	.history .historyListContent{
		margin-top:20px;
	}
</style>
